import * as HTMLComponent from "formiojs/components/html/HTML";

export class MyContentComponent extends HTMLComponent.default {

    public static schema(...extend) {
        return HTMLComponent.default.schema({
            label: "Content",
            type: "mycontent",
            key: "mycontent",
            input: false,
            content: "",
        }, ...extend);
    }

    public static get builderInfo() {
        return {
            title: "My Content",
            group: "basic",
            icon: "fab fa-html5",
            weight: 70,
            schema: {
                label: "Content",
                type: "mycontent",
                key: "mycontent",
                input: false,
                content: "<span>My - Content</span>",
                placeholder: "write your content here",
            },
        };
    }

    public elementInfo() {
        const info = super.elementInfo();
        info.type = "input";
        info.changeEvent = "input";
        return info;
    }

}
